import { Navigate } from 'react-router';

import { LOGIN } from '@/constants/routes';

const Home = () => {
  return <Navigate to={LOGIN} replace />;
};

export default Home;
